import { useState, useEffect, useContext } from 'react';
import { DndContext } from 'react-dnd';
export const useObservePreviews = () => {
  const [enabled, setEnabled] = useState(false);
  const dndContext = useContext(DndContext);
  useEffect(() => {
    var _dndContext$dragDropM;

    const backend = dndContext === null || dndContext === void 0 ? void 0 : (_dndContext$dragDropM = dndContext.dragDropManager) === null || _dndContext$dragDropM === void 0 ? void 0 : _dndContext$dragDropM.getBackend();
    const observer = {
      backendChanged: cbackend => {
        setEnabled(cbackend.previewEnabled());
      }
    };
    setEnabled(backend.previewEnabled());
    backend.previewsList().register(observer);
    return () => {
      backend.previewsList().unregister(observer);
    };
  }, [dndContext, dndContext.dragDropManager]);
  return enabled;
};